<template>
    <transition name="fade-top">
        <div class="ph-notice" v-if="show">
            <!-- <van-icon name="cross" size="20px" @click="downloadClose" /> -->
            <div class="wrapper">
            <img src="https://res.ponhu.cn/new/logo200_200.jpg" alt="" class="logo">
            <div class='tips-box'>
              <span style="font-weight: bold;">胖虎奢侈品</span>
              <span class="gift-info">领取1188元新人券，买满立减</span>
            </div>
            </div>
            <div class="download-btn">
              <a href="javascript:;" @click="download">立即打开</a>
              <!-- <span @click="download">立即打开</span> -->
            </div>
        </div>
    </transition>
</template>
<script>
import { openApp, BrowserInfo } from '@/utils'

export default {
  name: 'appDownload',
  mounted () {
    setTimeout(() => {
      this.fadeIn()
    }, 1000)
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    fadeIn () {
      this.show = true
    },
    download () {
      let bro = BrowserInfo()
      console.log(bro);
      if(bro.isAndroid) {
        location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.gian.punkhoo"
      } else {
        location.href = "https://apps.apple.com/app/apple-store/id1021204443?pt=117887550&ct=VIP&mt=8"
      }

    },
    downloadClose () {
      this.show = false
    }
  }
}
</script>
<style lang = 'less' scoped >
.fade-top-enter, .fade-top-leave-to {
  transform: translate3d(0, -100%, 0)
}
.fade-top-leave, .fade-top-enter-to {
  transform: translate3d(0, 0, 0)
}
.fade-top-enter-active, .fade-top-leave-active {
  transition: all .2s
}
.ph-notice{
  background: #fff;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  .wrapper{
    flex:1;
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #282828;
    .logo{
      width: 87px;
      height: 87px;
    }
    .tips-box{
      display: flex;flex-direction: column;margin-left: .3rem;
      text-align:left;
      .gift-info{font-size:24px;color:#999;padding-top: 0.1rem;}
    }
  }
  .download-btn{
    width:160px;
    height:56px;
    background:#FF9015;
    border-radius:28px;
    color: #fff;

    a{
      display: block;
      width:160px;
      height:56px;
      line-height: 56px;
      color: #000;
      font-size: 24px;
      text-align: center;
    }
  }
}
</style>
